export default {
  "input-container": "_input-container_1c1zkj"
};
